// config.js
const environments = {
    1: "http://localhost:3002",
    2: "https://d2backend-dot-ind-iusm-chiis-sw-dev.uc.r.appspot.com",
  };
  
  const selectedEnv =2;
  
  const config = {
    API_BASE_URL: environments[selectedEnv],
  };
  
  export default config;
